import { CREATE_ROTATIONSPLAN_VORLAGE } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useCreateRotationsplanVorlage/mutation';
import {
  Mitarbeiter_CreateRotationsplanVorlageMutation,
  Mitarbeiter_CreateRotationsplanVorlageMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useCreateRotationsplanVorlage() {
  const [execute, result] = useMutation<
    Mitarbeiter_CreateRotationsplanVorlageMutation,
    Mitarbeiter_CreateRotationsplanVorlageMutationVariables
  >(CREATE_ROTATIONSPLAN_VORLAGE, {
    refetchQueries: ['mitarbeiter_rotationsplanVorlagen'],
  });

  const createRotationsplanVorlage = useCallback(
    (variables: Mitarbeiter_CreateRotationsplanVorlageMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  return [createRotationsplanVorlage, result] as const;
}
